import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  show() {
    const url = apiRoutes.buyerMyBundlePath();

    return FetchHelpers.get(url);
  },
  update(attrs) {
    const url = apiRoutes.buyerMyBundlePath();

    return FetchHelpers.put(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/buyer/MyBundleRepository.js